
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workshops/[id]",
      function () {
        var mod = require("private-next-pages/workshops/[id].tsx");
        if (false && module.hot) {
          module.hot.accept("private-next-pages/workshops/[id].tsx", function () {
            if (!next.router.components["/workshops/[id]"]) return;
            var updatedPage = require("private-next-pages/workshops/[id].tsx");
            next.router.update("/workshops/[id]", updatedPage);
          });
        }
        return mod;
      }
    ]);
  